import { ChangeDetectorRef, EventEmitter, Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { FikoYTEnvIstemci } from './Environment/environment';
import { FikoYTArayuz } from './fikoyt.arayuz.service';
import { CihazKimlikService } from './fikoyt.cihaz-kimlik.service';
import { FikoYTIstekService, IstekOlayTuru } from './fikoyt.istek.service';
import { SocketFikoYT } from './fikoyt.socket.service';
import { FikoDexieDatabase } from './modules/fikoyt-dexie/fiko-dexie.database';
import { KimlikService } from './kimlik.service';
import { HttpClient } from '@angular/common/http';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { FikoYTIstekKok } from './modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';
import { FikoFloatingToolbarService } from './fikoyt-ui/src/lib/fiko-three-js/IFikoThreeJS/fiko-floating-toolbar/fiko-floating-toolbar.service';
import { SeriPortService } from './fikoyt.seri-port.service';

@Injectable({
  providedIn: 'root',
})
export class FikoYTService {
  env = FikoYTEnvIstemci;
  fapiUrl: string = FikoYTEnvIstemci.adres.url + ':' + FikoYTEnvIstemci.adres.fapiPort;
  /** */
  parametreler: { [key: string]: any } | any = {
    "altBaslik": {
      ismi: "baslik",
      turu: "Yazı",
      degeri: "FikoYT",
      ayarlar: {
        solSimge: "🏡"
      }
    },
    "Ana Sayfa Aktif Medya": {
      ismi: "baslik",
      turu: "Kimlik",
      degeri: null,
    },
    language: this.env.languages[0],
  }

  /** */
  degisti: EventEmitter<any> = new EventEmitter();

  /** */
  public readonly ayarlar: FikoDexieDatabase = new FikoDexieDatabase("FikoYT-Sistem", ["Sistem", "Ayarlar"], "Sistem");

  public kimlik: KimlikService;
  public io: SocketFikoYT;
  public toolbarService: FikoFloatingToolbarService;
  public seriPort: SeriPortService;

  constructor(public readonly router: Router,
    public readonly http: HttpClient,
    public readonly activatedRoute: ActivatedRoute,
    public readonly baslik: Title,
    public readonly arayuz: FikoYTArayuz,

    public readonly cihaz: CihazKimlikService,
    public readonly istekler: FikoYTIstekService,
    public readonly nzNotification: NzNotificationService,
  ) {
    /** */
    FikoYTIstekKok.httpClient = this.http;
    FikoYTIstekKok.Cihaz = this.cihaz;
    /** */
    this.kimlik = new KimlikService(this);
    this.io = new SocketFikoYT(this);
    this.toolbarService = inject(FikoFloatingToolbarService);
    this.seriPort = inject(SeriPortService);

    // setTimeout(() => {

      this.istekler.fapisteV1('POST', 'FikoYT.sistem.aktif-kullanici.bilgi').subscribe((snc: any) => {
        if (snc.turu == IstekOlayTuru.Cevaplandi) {
          this.io.off("FikoYT.sistem.cihaz.bağlandı.toplamlar");
          if (snc?.sonuc?.body?.durum?.hata != true) {
            // console.log(snc);
            this.kimlik.aktifKullaniciJson.set(snc?.sonuc?.body?.sonuc);
            this.io.fromEvent("FikoYT.sistem.cihaz.bağlandı.toplamlar").subscribe(async (data: any) => {
              // console.log(data);
              this.kimlik.cihazlar.set(data[0]);
            })

            this.io.kop();
            this.io.baglan();
          } else {
            this.io.kop();
            this.io.baglan();
          }
          // this.io.baglan();
        }
      })
    }
    // , 0)


    // this.io.baglan();


  // }

  public fikoIdUret(): string {
    // tslint:disable-next-line:no-bitwise
    const timestamp = (new Date().getTime() / 1000 | 0).toString(16);
    return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
      // tslint:disable-next-line:no-bitwise
      return (Math.random() * 16 | 0).toString(16);
    }).toLowerCase();
  }


}


